module.exports = __webpack_public_path__ + "static/media/tetris.5a551e73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tetris.jpg
// module id = 150
// module chunks = 0